export const sliderWatch = [
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2022/07/banner/800-200-800x200-166.png'
    },
    {
        id: 2,
        url: 'https://cdn.tgdd.vn/2022/08/banner/800-200-800x200-16.png'
    },
    {
        id: 3,
        url: 'https://cdn.tgdd.vn/2022/08/banner/800-200-800x200-17.png'
    },
    {
        id: 4,
        url: 'https://cdn.tgdd.vn/2022/08/banner/800-200-800x200-28.png'
    },
    {
        id: 5,
        url: 'https://cdn.tgdd.vn/2022/08/banner/800-200-800x200-29.png'
    },
    {
        id: 6,
        url: 'https://cdn.tgdd.vn/2022/08/banner/Layer-3-800x200.png'
    },
    {
        id: 6,
        url: 'https://cdn.tgdd.vn/2022/08/banner/Layer-1-800x200-1.png'
    }

]

export const bannerWatch = [
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2022/06/banner/2-390x97.png'
    },
    {
        id: 2,
        url: 'https://cdn.tgdd.vn/2022/06/banner/3-390x97.png'
    }
]

export const optionWatches = [
    {
        id: 1,
        title: 'Hãng'
    },
    {
        id: 2,
        title: 'Giá'
    },
    {
        id: 3,
        title: 'Giới tính'
    },
    {
        id: 4,
        title: 'Đường kính mặt'
    },
    {
        id: 5,
        title: 'Màu mặt'
    },
    {
        id: 6,
        title: 'Màu dây'
    },
    {
        id: 7,
        title: 'Kiểu mặt'
    },
    {
        id: 8,
        title: 'Loại mặt số'
    },
    {
        id: 9,
        title: 'Hình dáng mặt'
    },
    {
        id: 10,
        title: 'Chất liệu dây'
    },
    {
        id: 11,
        title: 'Chất liệu mặt kính'
    },
    {
        id: 12,
        title: 'Kháng nước'
    },
    {
        id: 13,
        title: 'Tiện ích'
    },
    {
        id: 14,
        title: 'Loại máy'
    },
    {
        id: 15,
        title: 'Phong cách'
    },
    {
        id: 16,
        title: 'Loại đồng hồ cao cấp'
    }
]

export const quickLink = [
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/mwgcart/mwgcore/ContentMwg/images/icons8-hot_price@2x.png',
        title: 'Giảm sốc',
        pathname: ''
    },
    {
        id: 2,
        url: 'https://cdn.tgdd.vn/mwgcart/mwgcore/ContentMwg/images/lw-man.png',
        title: 'Nam',
        pathname: '/dong-ho-danh-cho-nam'
    },
    {
        id: 3,
        url: 'https://cdn.tgdd.vn/mwgcart/mwgcore/ContentMwg/images/lw-women.png',
        title: 'Nữ',
        pathname: '/dong-ho-danh-cho-nu'
    },
    {
        id: 4,
        url: 'https://cdn.tgdd.vn/mwgcart/mwgcore/ContentMwg/images/lw-child.png',
        title: 'Trẻ em',
        pathname: '/dong-ho-tre-em'
    },
    {
        id: 5,
        url: 'https://cdn.tgdd.vn/mwgcart/mwgcore/ContentMwg/images/lw-couple.png',
        title: 'Cặp đôi',
        pathname: '/dong-ho-cap-doi'
    },
    {
        id: 6,
        url: 'https://cdn.tgdd.vn/mwgcart/mwgcore/ContentMwg/images/lw-albert.png',
        title: 'Dây đồng hồ',
        pathname: '/day-dong-ho'
    }
]

export const images = [
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2022/06/banner/MVW-STAR-420-X-260-420x260.png'
    },
    {   
        id: 2,
        url: 'https://cdn.tgdd.vn/2021/12/banner/03-420x260.png'
    },
    {
        id: 3,
        url:'https://cdn.tgdd.vn/2022/06/banner/420-x-260-420x260.png'
    },
    {
        id: 4,
        url: 'https://cdn.tgdd.vn/2021/12/banner/02-420x260.png'
    },
    {
        id: 5,
        url: 'https://cdn.tgdd.vn/2021/12/banner/01-420x260.jpg'
    },
    {
        id: 6,
        url: 'https://cdn.tgdd.vn/2021/06/banner/01-420x260.png'
    },
    {
        id: 7,
        url: 'https://cdn.tgdd.vn/2021/12/banner/06-420x260.png'
    },
    {
        id: 8,
        url: 'https://cdn.tgdd.vn/2022/04/banner/orrient-420x260.png'
    }
]

export const WatchCategories = [
    {
        id: 1,
        title: 'Đồng hồ độc quyền',
        url: 'https://cdn.tgdd.vn/2021/05/banner/DHDocquyendesk-330x428.jpg',
        pathname: '/dong-ho-doc-quyen'
        
    },

    {
        id: 2,
        title: 'Đồng hồ cao cấp',
        url: 'https://cdn.tgdd.vn/2021/05/banner/DHCaocapDesk-330x428.png',
        pathname: '/dong-ho-cao-cap'
        
    },

    {
        id: 3,
        title: 'Đồng hồ phái mạnh',
        url: 'https://cdn.tgdd.vn/2022/03/banner/Dhnamdesk-330x428-2.png',
        pathname: '/dong-ho-danh-cho-nam'
        
    },
    {
        id: 4,
        title: 'Đồng hồ phái nữ',
        url: 'https://cdn.tgdd.vn/2022/07/banner/dh-nu-desk-330x428.png',
        pathname: '/dong-ho-danh-cho-nu'
        
    },
    {
        id: 5,
        title: 'Đồng hồ cặp đôi',
        url: 'https://cdn.tgdd.vn/2022/07/banner/dh-cap-desk-330x428.png',
        pathname: '/dong-ho-cap-doi'
    },
    {
        id: 6,
        title: 'Đồng hồ trẻ em',
        url: 'https://cdn.tgdd.vn/2021/04/banner/DHTreemdesktop3-330x428.jpg',
        pathname: '/dong-ho-tre-em'
    }

]


export const listWatchProducts = [
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/Products/Images/7264/247105/dong-ho-nam-mvw-ml064-01-1.-600x600.jpg',
        catproduct: 'MVW',
        nameproduct: 'ML064-01',
        priceold : '1.990.000đ',
        discount : '-40%',
        pricenew: '1.194.000đ'
        


    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/Products/Images/7264/247105/dong-ho-nam-mvw-ml064-01-1.-600x600.jpg',
        catproduct: 'MVW',
        nameproduct: 'ML064-01',
        priceold : '1.990.000đ',
        discount : '-40%',
        pricenew: '1.194.000đ'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/Products/Images/7264/247105/dong-ho-nam-mvw-ml064-01-1.-600x600.jpg',
        catproduct: 'MVW',
        nameproduct: 'ML064-01',
        priceold : '1.990.000đ',
        discount : '-40%',
        pricenew: '1.194.000đ'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/Products/Images/7264/247105/dong-ho-nam-mvw-ml064-01-1.-600x600.jpg',
        catproduct: 'MVW',
        nameproduct: 'ML064-01',
        priceold : '1.990.000đ',
        discount : '-40%',
        pricenew: '1.194.000đ'
        
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/Products/Images/7264/247105/dong-ho-nam-mvw-ml064-01-1.-600x600.jpg',
        catproduct: 'MVW',
        nameproduct: 'ML064-01',
        priceold : '1.990.000đ',
        discount : '-40%',
        pricenew: '1.194.000đ'
        
    },
    
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/Products/Images/7264/247105/dong-ho-nam-mvw-ml064-01-1.-600x600.jpg',
        catproduct: 'MVW',
        nameproduct: 'ML064-01',
        priceold : '1.990.000đ',
        discount : '-40%',
        pricenew: '1.194.000đ'
        
    },
    
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/Products/Images/7264/247105/dong-ho-nam-mvw-ml064-01-1.-600x600.jpg',
        catproduct: 'MVW',
        nameproduct: 'ML064-01',
        priceold : '1.990.000đ',
        discount : '-40%',
        pricenew: '1.194.000đ'
        
    },
    
]

export const wt_mono_categories = [
    {
        catid: 1,
        catname: 'MVW'
    },
    {
        catid: 2,
        catname: 'ELIO'
    },
    {
        catid: 3,
        catname: 'SMILE KID'
    },
    {
        catid: 4,
        catname: 'KORLEX'
    },
    {
        catid: 5,
        catname: 'DAUMIER'
    }
]

export const wt_high_end_categories = [
    {
        catid: 1,
        catname: 'ORIENT'
    },
    {
        catid: 2,
        catname: 'MOVADO'
    },
    {
        catid: 3,
        catname: 'CASIO PROTREK'
    },
    {
        catid: 4,
        catname: 'CITIZEN'
    },
    {
        catid: 5,
        catname: 'G-SHOCK'
    },
    {
        catid: 6,
        catname: 'EDIFICE CASIO'
    }
]

export const wt_for_men_categories = [
    {
        catid: 1,
        catname: 'Đồng hồ thời trang'
    },
    {
        catid: 2,
        catname: 'Đồng hồ thông minh'
    },
    
]

export const wt_for_women_categories = [
    {
        catid: 1,
        catname: 'Đồng hồ thời trang'
    },
    {
        catid: 2,
        catname: 'Đồng hồ thông minh'
    },
    
]

export const wt_for_couple_categories = [
    {
        catid: 1,
        catname: 'Dây da'
    },
    {
        catid: 2,
        catname: 'Kim loại'
    },
    {
        catid: 3,
        catname: 'Kim'
    }
    
]


export const wt_for_children_categories = [
    {
        catid: 1,
        catname: 'Dây da'
    },
    {
        catid: 2,
        catname: 'Kim loại'
    },
    {
        catid: 3,
        catname: 'Kim'
    }
    
]

export const line_strap = [
    {
        id: 1,
        name: 'Đồng hồ thời trang',
        url: 'https://cdn.tgdd.vn/Category/Quicklink/7978/1/090521-050308.jpg'
    },
    {
        id: 2,
        name: 'Apple Watch',
        url: 'https://cdn.tgdd.vn/Category/Quicklink/7978/1/090521-051259.jpg'
    },
    {
        id: 3,
        name: 'Miband',
        url: 'https://cdn.tgdd.vn/Category/Quicklink/7978/1/090521-050915.jpg'
    },
    {
        id: 4,
        name: 'Samsung Watch',
        url: 'https://cdn.tgdd.vn/Category/Quicklink/7978/1/090521-050919.jpg'
    },
    {
        id: 5,
        name: 'Huawei Watch',
        url: 'https://cdn.tgdd.vn/Category/Quicklink/7978/1/090521-050925.jpg'

    },
    {
        id: 6,
        name: 'Da tổng hợp',
        url: 'https://cdn.tgdd.vn/Category/Quicklink/7978/1/030521-113903.jpg'
    },
    {
        id: 7,
        name: 'Silicone',
        url: 'https://cdn.tgdd.vn/Category/Quicklink/7978/1/280421-091748.jpg'
    }

]

export const width_line_strap = [12,14,16,18,22]


export const list_box_filter_watch = [
    {
        id:1,
        title: 'Hãng',
        name:'brand',
        dropDown: [
            {
                id:1,
                img:'https://cdn.tgdd.vn/Brand/1/Casio7264-b_39.jpg'
            },
            {
                id:2,
                img:'https://cdn.tgdd.vn/Brand/1/ORIENTl-220x48.jpg'
            },
            {
                id:3,
                img:'https://cdn.tgdd.vn/Brand/1/Movado-l-220x48-1.jpg'
            },
            {
                id:4,
                img:'https://cdn.tgdd.vn/Brand/1/logo-protrek-220x48-5.jpg'
            },
            {
                id:5,
                img:'https://cdn.tgdd.vn/Brand/1/Citizen7264-b_41.jpg'
            },
            {
                id:6,
                img:'https://cdn.tgdd.vn/Brand/1/G-shock7264-b_36.jpg'
            },
            {
                id:7,
                img:'https://cdn.tgdd.vn/Brand/1/Baby-G7264-b_39.jpg'
            },
            {
                id:8,
                img:'https://cdn.tgdd.vn/Brand/1/TITANl-220x48.png'
            },
            {
                id:9,
                img:'https://cdn.tgdd.vn/Brand/1/Elio7264-b_49.jpg'
            },
            {
                id:10,
                img:'https://cdn.tgdd.vn/Brand/1/NAKZENl-220x48.png'
            },
            {
                id:11,
                img:'https://cdn.tgdd.vn/Brand/1/Q&Q7264-b_51.jpg'
            },
            {
                id:12,
                img:'https://cdn.tgdd.vn/Brand/1/rossini7264-99(220%C3%9748px)(1)-220x48.jpg'
            },
            {
                id:13,
                img:'https://cdn.tgdd.vn/Brand/1/Frame3-220x48.jpg'
            },
            {
                id:14,
                img:'https://cdn.tgdd.vn/Brand/1/LascoteL-220x48.jpg'
            },
        ],
    },
    {
        id:2,
        title: 'Giá',
        name:'price',
        dropDown: [
            {
                content:'Dưới 1 triệu'
            },
            {
                content:'Từ 1 - 3 triệu'
            },
            {
                content:'Từ 3 - 5 triệu'
            },
            {
                content:'Từ 5 - 7 triệu'
            },
            {
                content:'Từ 7 - 15 triệu'
            },
            {
                content:'Từ 15 - 30 triệu'
            },
            {
                content:'Trên 30 - 50 triệu'
            },
            {
                content:'Trên 50 triệu'
            },
        ],
    },
    {
        id:3,
        title: 'Giới tính',
        name:'gender',
        dropDown: [
            {
                content:'Nam'
            },
            {
                content:'Nữ'
            },
            {
                content:'Cặp đôi'
            },
            {
                content:'Trẻ em'
            },
            {
                content:'Unisex'
            },
        ],
    },
    {
        id:4,
        title: 'Đường kính mặt',
        name:'diameter',
        dropDown: [
            {
                content:'Dưới 29 mm'
            },
            {
                content:'29 - 33 mm'
            },
            {
                content:'33 - 37 mm'
            },
            {
                content:'37 -40 mm'
            },
            {
                content:'40 - 42 mm'
            },
            {
                content:'42 - 45 mm'
            },
            {
                content:'Trên 45 mm'
            },
        ],
    },
    {
        id:5,
        title: 'Màu sắc',
        name:'color',
        dropDown: [
            {
                content:'Bạc'
            },
            {
                content:'Cam'
            },
            {
                content:'Đen'
            },
            {
                content:'Đỏ'
            },
            {
                content:'Hồng'
            },
            {
                content:'Kem'
            },
            {
                content:'Nâu'
            },
            {
                content:'Tím'
            },
            {
                content:'Trắng'
            },
            {
                content:'Vàng'
            },
        ],
    },
   
]


